import { useState } from 'react'
import i18next from 'i18next'
import i18n from '../../i18n/i18n'
import './LanguageSwitcher.scss'

const LanguageSwitcher = () => {
  const [lang, setLang] = useState(i18next.language)

  const changeLanguage = (lang: string) => {
    setLang(lang)
    localStorage.setItem('lang', lang)
    i18n.changeLanguage(lang)
    lang === 'tr' ? localStorage.setItem('culture', 'tr-TR') : localStorage.setItem('culture', 'en-US')
    window.location.reload()
  }

  return (
    <div>
      <button
        className={lang === 'tr' ? 'chosen-button tr-button' : 'not-chosen tr-button'}
        onClick={() => changeLanguage('tr')}>
        TR
      </button>
      <button
        className={lang === 'en' ? 'chosen-button en-button' : 'not-chosen en-button'}
        onClick={() => changeLanguage('en')}>
        EN
      </button>
    </div>
  )
}

export default LanguageSwitcher
